import { render, staticRenderFns } from "./FollowInterestForm.vue?vue&type=template&id=b83a0966&"
import script from "./FollowInterestForm.vue?vue&type=script&lang=js&"
export * from "./FollowInterestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports